import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'application';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const INITIALIZED = `${NAMESPACE}/INITIALIZED`;
export const CLEANUP = `${NAMESPACE}/CLEANUP`;
export const UPDATE_LAST_USED_DC = `${NAMESPACE}/UPDATE_LAST_USED_DC`;
export const DISMISS_EXPIRED_TRIAL_MODAL = `${NAMESPACE}/DISMISS_EXPIRED_TRIAL_MODAL`;
export const DISMISS_UNVERIFIED_ALERT = `${NAMESPACE}/DISMISS_UNVERIFIED_ALERT`;

// Growth API Calls
export const GET_CORD_TOKEN = createApiNamespacedConstants('GET_CORD_TOKEN');
export const GET_USER_ATTRIBUTES = createApiNamespacedConstants('GET_USER_ATTRIBUTES');

export const SWITCH_ACTIVE_TEAM = createApiNamespacedConstants('SWITCH_ACTIVE_TEAM');
